export const currencyFormatNew = (num) => {
  return num?.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const timeStampToDate = (data) => {
  const date = new Date(data);

  // Custom date format (e.g., "Month Day, Year")
  const customFormattedDate = date.toLocaleDateString('en-US', {

    month: 'short',
    day: 'numeric',
  });
  return customFormattedDate;

};


// export const getRemainingMinutes = (until) => {
//   const currentTime = new Date().getTime();
//   const remainingTime = until - currentTime;

//   return remainingTime < 15 * 60 * 1000; // 15 minutes in milliseconds
// };


/**
 * Checks if remaining time is within the auto-extend window.
 *
 * @param {number} until - Target timestamp in milliseconds
 * @param {number} windowMinutes - Auto-extend window in minutes (default: 15)
 * @returns {boolean} True if remaining time is less than windowMinutes
 */
export const isWithinAutoExtendWindow = (until, windowMinutes = 15) => {
  const currentTime = new Date().getTime();
  const remainingTime = until - currentTime;
  const windowMs = windowMinutes * 60 * 1000;
  return remainingTime < windowMs;
};

/**
 * @deprecated Use isWithinAutoExtendWindow instead.
 * Kept for backward compatibility.
 */
export const isLessThan15MinutesLeft = (until) => {
  return isWithinAutoExtendWindow(until, 15);
};


export const eventDateFormatter = (date) => {
  const dateArr = date.split("-");
  let formattedDate = "";
  if (dateArr.length === 3) {
    const [year, month, day] = dateArr;
    formattedDate = `${month}/${day}/${year}`;
  }
  return formattedDate;
};
export const ValidationUtils = {
  // Validate first name and last name: Non-empty and only alphabet characters
  validateName: (name) => {
    if (!name) return "Name cannot be empty.";
    if (!/^[a-zA-Z\s]+$/.test(name)) return "Name must contain only alphabetic characters.";
    return null;
  },

  // Validate company name: Non-empty
  validateCompanyName: (companyName) => {
    if (!companyName) return "Company name cannot be empty.";
    return null;
  },

  // Validate email: Standard email format
  validateEmail: (email) => {
    if (!email) return "Email cannot be empty.";
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) return "Invalid email format.";
    return null;
  },

  // Validate phone: Numerical only and specific length (e.g., 10 digits)
  validatePhone: (phone) => {
    if (!phone) return "Phone number cannot be empty.";
    if (!/^\d{10}$/.test(phone)) return "Phone number must be 10 digits.";
    return null;
  },

  // Validate comments: Optional but has a length check
  validateComments: (comments) => {
    if (comments && comments.length > 500) return "Comments cannot exceed 500 characters.";
    return null;
  },

  // Validate property information: Non-empty
  validatePropertyInfo: (propertyInfo) => {
    if (!propertyInfo) return "Property information cannot be empty.";
    return null;
  },

  // Validate state, city, and ZIP: Non-empty and ZIP should be numeric
  validateAddress: ({ state, city, zip }) => {
    if (!state) return "State cannot be empty.";
    if (!city) return "City cannot be empty.";
    if (!zip) return "ZIP code cannot be empty.";
    if (!/^\d+$/.test(zip)) return "ZIP code must contain only numbers.";
    return null;
  },

  // General form submission validation
  validateForm: (formData) => {
    const errors = {};

    errors.firstName = ValidationUtils.validateName(formData.firstName);
    errors.lastName = ValidationUtils.validateName(formData.lastName);
    errors.companyName = ValidationUtils.validateCompanyName(formData.companyName);
    errors.email = ValidationUtils.validateEmail(formData.email);
    errors.phone = ValidationUtils.validatePhone(formData.phone);
    errors.comments = ValidationUtils.validateComments(formData.comments);
    errors.propertyInfo = ValidationUtils.validatePropertyInfo(formData.propertyInfo);

    const addressError = ValidationUtils.validateAddress({
      state: formData.state,
      city: formData.city,
      zip: formData.zip,
    });
    if (addressError) errors.address = addressError;

    // Filter out null values (no errors)
    return Object.fromEntries(
      Object.entries(errors).filter(([_, value]) => value !== null)
    );
  },
};



